const STICKER_TEXT_CLASSNAME = "sticker-text";

const formatNumber = (num) => {
  if (num >= 1000) {
    return num.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1.');
  }
  return num.toString();
};

const updateCount = (element, target) => {
  let count = 0;

  const animate = () => {
    const increment = Math.max(1, Math.ceil(target / 200));

    if (count < target) {
      count += increment;
      const displayValue = count >= target ? target : count;
      element.innerText = formatNumber(displayValue);
      setTimeout(animate, 20);
    } else {
      element.innerText = formatNumber(target);
    }
  };

  animate();
};

function initializeCounterAnimationTrigger() {
  const stickerElements = document.querySelectorAll(".sticker.scroll-trigger");
  if (stickerElements.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const stickerElement = entry.target;
          const strongElement = stickerElement.querySelector(`.${STICKER_TEXT_CLASSNAME} > p > strong`);

          if (!strongElement) return;

          const str = strongElement.innerText;
          const stringContainsNumber = isFirstCharNumber(str);

          if (!stringContainsNumber) return;

          let stripped = str;
          const hasPlus = stripped.includes("+");

          if (hasPlus) {
            stripped = stripped.replace("+", "");
            strongElement.classList.add("has-plus");
          }

          // Verwijder Duitse duizendtal-punten
          stripped = stripped.replace(/\./g, "");

          const number = Number(stripped);
          strongElement.innerText = "0";
          updateCount(strongElement, number);

          // Stop observing na eerste trigger
          observer.unobserve(stickerElement);
        }
      });
    },
    {
      rootMargin: "0px 0px -50px 0px",
    },
  );

  stickerElements.forEach((element) => observer.observe(element));
}

function isFirstCharNumber(str) {
  if (!str || str.length === 0) return false;
  return !isNaN(str[0]);
}

window.addEventListener("DOMContentLoaded", () => {
  initializeCounterAnimationTrigger();
});
